
<mat-card class="filter settingHeader">
  <div class="name">
    Message Templates
  </div>
  <div class="quickAction">    
 
  </div>
</mat-card>

<div class="documents">
  <mat-card class="example-list rowholder" *ngIf="!ShowNoRecordFound">
    <div class="fieldRow head">
      <span class="moveicon"></span>
      <span class="fieldName">Subject</span> 
      <span class="fieldName">Message</span> 
      <span class="fieldName">Type</span> 
      <span class="editField">Edit</span> 
      <span class="delete">Delete</span>
    </div>
    <div class="example-box fieldRow" *ngFor="let temp of templateList">
      <span class="moveicon"></span>
      <span class="fieldName">{{temp.subject}}</span>
      <span class="fieldName">{{temp.message}}</span>
      <span class="fieldName" *ngIf="temp.typeID==1">BroadCast</span>
      <span class="fieldName" *ngIf="temp.typeID==2">Request Document</span>
      <span class="fieldName" *ngIf="temp.typeID==3">Fax</span> 
      <span class="fieldName" *ngIf="temp.typeID==4">Project</span> 
      <span class="editField">
        <button mat-icon-button class="editbtn" (click)="openDialogWithRef(myDialog,temp)">
          <mat-icon>edit</mat-icon>
        </button>
      </span>

      <span class="delete">
        <button mat-icon-button class="trash" (click)="deleteTemplate(temp)">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </span>
    </div>    
    <mat-paginator [pageIndex]="pageIndex" [pageSize]="pageSize" [length]="paginatorTotalLength" [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons  (page)="CallNextPrevPageData($event)"></mat-paginator>
  </mat-card>

  <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>

</div>


<ng-template #myDialog>
  <form  [formGroup]="formDialog">
  <h2 mat-dialog-title>
      Edit Message Template
      <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
      </button>
  </h2>
  
<mat-dialog-content class="mat-typography">
  <mat-form-field class="example-full-width">
      <mat-label>Subject</mat-label>
      <input matInput [required]="true"  placeholder="Edit subject" formControlName="subject" [(ngModel)]="editType.subject" />
      <mat-error
      *ngIf="formDialog.get('subject').invalid &&
        (formDialog.get('subject').dirty ||
        formDialog.get('subject').touched)">
      <span>This field is mandatory.</span>
    </mat-error>
    </mat-form-field>  

    <mat-form-field class="example-full-width">
      <mat-label>Message</mat-label>
      <textarea matInput placeholder="Type Message"
       formControlName="message" [(ngModel)]="editType.message"
                              cdkTextareaAutosize
                              cdkAutosizeMinRows="3"
                              cdkAutosizeMaxRows="5"
                             >
                            </textarea>

      <!-- <input matInput [required]="true"   /> -->
      <mat-error
      *ngIf="formDialog.get('message').invalid &&
        (formDialog.get('message').dirty ||
        formDialog.get('message').touched)">
      <span>This field is mandatory.</span>
    </mat-error>
    </mat-form-field>  

</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" 
  [disabled]="formDialog.invalid || !formDialog.dirty"   
  (click)="UpdateTypeDetails()">
    Update
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
</mat-dialog-actions>
<app-loader></app-loader>
</form>
</ng-template>


<app-loader></app-loader>